


















































import {
  Component, Vue, Prop, Watch,
} from 'vue-property-decorator';
import Loader from '@/components/Loader.vue';

@Component({
  components: {
    Loader,
  },
})
export default class Pagination extends Vue {
  @Prop(Number) totalPage!: number;
  @Prop(Number) from!: number;
  @Prop(Number) to!: number;
  @Prop(Number) totalItem!: number;
  @Prop(Number) value!: number;
  @Prop(Boolean) loading!: boolean;

  startPage = 1;
  endPage = this.totalPage;
  diff = 0;

  mounted() {
    this.onValueChange();
  }

  @Watch('value')
  @Watch('totalPage')
  onValueChange() {
    this.startPage = this.value < 5 ? 1 : (this.value - 4);
    this.endPage = this.startPage + 8;
    this.endPage = this.totalPage < this.endPage ? this.totalPage : this.endPage;
    this.diff = this.startPage - this.endPage + 8;
    this.startPage -= ((this.startPage - this.diff > 0) ? this.diff : 0);
  }

  changePage(val: number) {
    this.currentPage = val;
  }

  get currentPage() {
    return this.value;
  }

  set currentPage(value) {
    this.$emit('input', value);
  }
}
